import React, { useState } from 'react';
import { VERTICAL_ALIGN } from '../constants';
import useIntersectionObserver from '@react-hook/intersection-observer';
import Grid from './grid';

const Section = ({
  halign = false,
  children,
  className,
  isMain = false,
  isCompact = false,
  style,
  ...props
}) => {
  const classNames = [];
  const [ref, setRef] = useState();

  const { isIntersecting } = useIntersectionObserver(ref, observerConfig);

  if (halign) classNames.push(`h-${halign}`);
  if (className) classNames.push(className);
  if (!isIntersecting) classNames.push('isHidden');
  if (isMain) classNames.push('isMain');
  if (isCompact) classNames.push('isCompact');

  const localStyle = isCompact ? { margin: 0 } : {};
  const fullStyle = { ...style, ...localStyle };

  return (
    <section
      ref={setRef}
      className={classNames.join(' ')}
      data-module
      data-layout-section
      data-use-palette
      {...props}
      style={fullStyle}
    >
      {children}
    </section>
  );
};

const Cols = ({ valign = VERTICAL_ALIGN.CENTER, children, className, isCompact, ...props }) => {
  const classNames = [];
  const [ref, setRef] = useState();
  const { isIntersecting } = useIntersectionObserver(ref, observerConfig);

  if (className) classNames.push(className);
  if (valign) classNames.push(`v-${valign}`);
  if (!isIntersecting) classNames.push('isHidden');

  return (
    <section
      ref={setRef}
      className={classNames.join(' ')}
      data-module
      data-layout-columns
      data-use-palette
      {...props}
    >
      {children}
    </section>
  );
};

const observerConfig = {
  rootMargin: '100% 0px -20% 0px',
};

export { Section, Cols, Grid };
